// カスタムプロパティ定義
export const setCustomProperties = (container) => {
  // iosのメニューバーを除いたvhの動的取得
  (() => {
    var customViewportCorrectionVariable = "vh";
    function setViewportProperty(doc) {
      var prevClientHeight;
      var customVar = "--" + (customViewportCorrectionVariable || "vh");
      function handleResize() {
        var clientHeight = doc.clientHeight;
        if (clientHeight === prevClientHeight) return;
        requestAnimationFrame(function updateViewportHeight() {
          doc.style.setProperty(customVar, clientHeight * 0.01 + "px");
          prevClientHeight = clientHeight;
        });
      }
      handleResize();
      return handleResize;
    }

    window.addEventListener("resize", setViewportProperty(document.documentElement));
  })();

  // articleの横幅を取得
  (() => {
    const article = container.querySelector("[data-article]");
    if (article == null) return false; // 要素がなければ終了
    let articleWidth;

    function updatePropertyArticleWidth() {
      articleWidth = article.clientWidth;
      document.documentElement.style.setProperty("--article-width", articleWidth + "px");
    }

    updatePropertyArticleWidth();
    window.addEventListener("resize", updatePropertyArticleWidth);
  })();

  (() => {
    const adOverlay = container.querySelector(".g-ad-overlay");
    const setAdOverlayHeight = () => {
      if (!adOverlay) {
        document.documentElement.style.setProperty("--ad-overlay-height", "0px");
        return false;
      }

      setTimeout(() => {
        document.documentElement.style.setProperty("--ad-overlay-height", adOverlay.clientHeight + "px");
      }, 100);
    };

    setAdOverlayHeight();
    window.addEventListener("load", setAdOverlayHeight);
    window.addEventListener("resize", setAdOverlayHeight);
  })();

  // headerロゴの高さを設定
  (() => {
    const header = document.querySelector(".l-header");
    if (!header) return false;

    const getImage = () => header.querySelector(".l-header__image");
    const resizeObserver = new ResizeObserver(() => {
      setTimeout(() => {
        document.documentElement.style.setProperty("--header-height", getImage() ? header.clientHeight + "px" : null);
      }, 200);
    });

    resizeObserver.observe(header);
    return false;
  })();

  // 記事アイキャッチの高さを設定
  (() => {
    const postEyeCatch = () => document.querySelector("[data-post-eye-catch]");
    if (!postEyeCatch()) return false;

    const resizeObserver = new ResizeObserver(() => {
      setTimeout(() => {
        document.documentElement.style.setProperty("--post-eye-catch-height", postEyeCatch() ? postEyeCatch().clientHeight + "px" : null);
      }, 200);
    });

    resizeObserver.observe(postEyeCatch());
    return false;
  })();
};
